import React, { useEffect } from 'react';
import { useField } from 'formik';
import { useTranslation } from 'react-i18next';

import FieldArrayIterables from '~/commons/components/FieldArrayIterables.jsx';
import FormGroup from '~/commons/components/FormGroup.jsx';
import { numToLetter } from '~/commons/helpers';

const FieldsOrdering = ({
  qtnIndex: i,
  restrictEdit = false,
  fileUploadUrl,
}) => {
  const [, { value, touched }] = useField(`questions.${i}`);
  const [,, { setValue: setAns }] = useField(`questions.${i}.answers`);
  const { t } = useTranslation();
  let { choices } = value;
  const { answers } = value;

  // take out the last empty choice
  if (!restrictEdit && !choices.slice(-1)[0]) {
    choices = choices.slice(0, -1);
  }

  useEffect(() => {
    if (answers.length !== choices.length) {
      // ensure right number of answers
      let a = answers.slice(0, choices.length);

      a.push(...choices.slice(a.length).map(() => '0'));
      // make sure answers are within one of the choices
      a = a.map((k) => (k >= choices.length ? '0' : k.toString()));

      setAns(a);
    }
  }, [choices.length]);
  useEffect(() => {
    if (touched) {
      // reset field when switch from other question format
      setAns(choices.map((c, k) => k.toString()));
    }
  }, []);

  return (
    <div className="row">
      <div className="col">
        <label>{t('Items')} *</label>
        <FieldArrayIterables
          name={`questions.${i}.choices`}
          {...restrictEdit ? {} : {
            tail: { text: '', img: '' }, // Default structure for new choices
          }}
        >
          {(c, ii) => {
            // Handle both string and object formats
            const isObject = typeof c === 'object' && c !== null;
            const choiceText = isObject ? c.text || '' : c || '';

            return (
              <div className="form-row align-items-start mb-3" key={ii}>
                <div className="col-auto pt-2">
                  {numToLetter(ii, true)}.
                </div>
                <div className="col">
                  {/* Choice Text Input */}
                  <FormGroup
                    name={isObject ? `questions.${i}.choices.${ii}.text` : `questions.${i}.choices.${ii}`}
                    label="Item Text"
                    placeholder={isObject && c.img ? 'Enter item text (optional)' : 'Enter item text...'}
                  />

                  {/* Image Upload */}
                  {(isObject || choiceText.trim()) && (
                    <FormGroup as="coverImg" api={fileUploadUrl} name={`questions.${i}.choices.${ii}.img`} label="Image (optional)" className="mt-2" />
                  )}
                </div>
              </div>
            );
          }}
        </FieldArrayIterables>
      </div>
      <div className="col">
        <label>{t('Order')} *</label>
        {answers.map((a, ii) => (
          <FormGroup
            key={ii}
            name={`questions.${i}.answers.${ii}`}
            as="select"
            label={null}
          >
            {choices.map((c, iii) => {
              const displayText = typeof c === 'object' ? c.text || `Item ${iii + 1}` : c || `Item ${iii + 1}`;
              return (
                <option
                  key={iii}
                  value={iii}
                >{displayText}</option>
              );
            })}
          </FormGroup>
        ))}
      </div>
    </div>
  );
};

export default FieldsOrdering;
